export enum GlobalSortDirectionEnum {
  Ascending = 'asc',
  Descending = 'desc',
}

export function oppositeSortDirection (sortDirection: GlobalSortDirectionEnum): GlobalSortDirectionEnum {
  if (sortDirection === GlobalSortDirectionEnum.Ascending) {
    return GlobalSortDirectionEnum.Descending
  } else {
    return GlobalSortDirectionEnum.Ascending
  }
}
